import {RouteEnum} from "@/router/RouteEnum.ts";
import NotFoundView from "@/views/NotFoundView.vue";

const notFound = {
  path: '/404',
  name: RouteEnum.NotFound,
  component: NotFoundView,
}

const failureRoutes = [notFound]
export default failureRoutes
